// extracted by mini-css-extract-plugin
export var orderDetails = "_uu-2";
export var orderImage = "_uu-1";
export var orderMeta = "_uu-3";
export var orderSummary = "_uu-0";
export var rightArrow = "_uu-4";